export default __webpack_public_path__ + "static/media/nikhil.9169469e.jpg";